const params = new URLSearchParams(window.location.search);

function getProcessEnvVar (varName) {
    // Returns the value of a process.env var
    // Raise an error if the value is null, undefined or ''
    var v = process.env[varName];
    if (v === undefined || v === null || v === "") {
        throw new Error(varName + " not found in process.env");
    }
    return v;
}

const getNewsroomUrl = (workspaceId, admin) => {
  var ret = location.protocol + '//' + getProcessEnvVar('VUE_APP_NEWSROOM_DOMAIN');
  if(workspaceId !== undefined) {
    ret += '/'+workspaceId;
  }
  if (admin === true) {
    ret += '/admin';
  }
  return ret; 
}

const isPreview = params.get("preview") === "true";

export {
  getNewsroomUrl,
  getProcessEnvVar,
  isPreview,
}
